<template>
</template>

<script>

	export default {
		name: 'LayerLoader',
		computed: {
			location() { return this.$store.state.location },
			layers: {
				get() { return this.$store.state.layers},
				set(value) {
					this.$store.commit('setState', ["layers", value]);
				}
			},
			map() {
				return this.$store.state.map.map
			},
		},
		mounted() {
			this.layers = require(`../../config/scenarios/${this.location.id}/layers.json`);
			this.init();
		},
		methods: {
			init: function() {
				for (let i in this.layers) {
					this.loadLayer(this.layers[i]);
				}
			},
			loadLayer(rec) {
				let img = require(`assets/img/${rec.img}`);
				var geoimg = new ol.layer.Image({
					name: "floor-"+rec.id,
					id: rec.id,
					type: 'layer',
					opacity: rec.opacity,
					source: new ol.source.GeoImage({
						url: img,
						imageCenter: ol.proj.fromLonLat([rec.long, rec.lat]),
						imageScale: [rec.scale_x, rec.scale_y],
						imageRotate: (this.map.getView().getRotation() * -1) + rec.rotation * (Math.PI/180),
						projection: 'EPSG:3857'
					})
				});
				this.map.addLayer(geoimg);
			}
		}
	}
</script>
